import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PlanTermsModalComponent } from '../../subscription-plans/plan-terms-modal/plan-terms-modal.component';

@Component({
  selector: 'app-terms-condtions',
  templateUrl: './terms-condtions.component.html',
  styleUrls: ['./terms-condtions.component.scss']
})
export class TermsCondtionsComponent implements OnInit {

  constructor(
    private modalService: NgbModal,
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
  }

  closeDialog() {
    this.activeModal.close();
  }

  openPlanTermsModal() {
    this.activeModal.close();
    this.modalService.open(PlanTermsModalComponent, { size: "lg", centered: true });
  }

}
